import { clientId, lpRequest } from '../../../../core/api/lp-request';
import { getDeliveryPermissions } from './get-delivery-permissions';

export const removeDeliveryPermission = async (
  driver_id: string,
  promisor_id: string,
  hub_id: string
): Promise<any> => {
  await lpRequest(`/fleet/${clientId()}/fleet/bulk-driver-assign`, {
    method: 'POST',
    body: { assign: false, driver_ids: [driver_id], hub_id, promisor_id }
  });

  return getDeliveryPermissions(driver_id);
};
